module.exports = __webpack_public_path__ + "static/img/235.3b1436c8.png";